var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.572 3.46606H3.66973C3.17296 3.46606 2.77026 3.86877 2.77026 4.36553V12.4348L6.88742 7.93003C7.42493 7.34192 8.35869 7.3662 8.86491 7.98143L13.7505 13.9192L17.1391 11.274C17.7225 10.8187 18.5387 10.8114 19.1301 11.2563L21.4715 13.0177V4.36553C21.4715 3.86877 21.0688 3.46606 20.572 3.46606ZM3.66973 2.0166C2.37245 2.0166 1.3208 3.06825 1.3208 4.36553V21.2678C1.3208 22.5651 2.37245 23.6168 3.66973 23.6168H20.572C21.8693 23.6168 22.921 22.5651 22.921 21.2678V4.36553C22.921 3.06825 21.8693 2.0166 20.572 2.0166H3.66973ZM12.1195 9.1047C12.776 9.1047 13.3083 8.57245 13.3083 7.91589C13.3083 7.25933 12.776 6.72708 12.1195 6.72708C11.4629 6.72708 10.9307 7.25933 10.9307 7.91589C10.9307 8.57245 11.4629 9.1047 12.1195 9.1047Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.18f6b2626dbe509ef9e1966eda437018.svg";
export { ForwardRef as ReactComponent };